module.exports = __webpack_public_path__ + "static/media/load-grey.02b000e6.svg";